"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpoPushReceiptsResponseSchema = exports.ExpoPushReceiptSchema = exports.ExpoPushSendResponseSchema = exports.ExpoPushTicketSchema = exports.ExpoPushMessageSchema = void 0;
const zod_1 = require("zod");
// Schema-first: types are z.infer-derived below, not hand-written interfaces checked against the
// schema. A `z.ZodType<T>` annotation here fails to type-check under this app's `strict: false`
// tsconfig (zod infers every property as optional in that mode), so there's no annotation that
// both satisfies the typedef rule and actually type-checks — same issue documented on
// SaveDriverPreferencesRequestSchema in packages/shared/types/src/driver-preferences.ts.
exports.ExpoPushMessageSchema = zod_1.z.object({
    to: zod_1.z.string(),
    title: zod_1.z.string().optional(),
    body: zod_1.z.string().optional(),
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
// Same reason as ExpoPushMessageSchema above
exports.ExpoPushTicketSchema = zod_1.z.union([
    zod_1.z.object({ status: zod_1.z.literal('ok'), id: zod_1.z.string() }),
    zod_1.z.object({
        status: zod_1.z.literal('error'),
        message: zod_1.z.string(),
        details: zod_1.z.object({ error: zod_1.z.string().optional() }).optional(),
    }),
]);
// Same reason as ExpoPushTicketSchema above
exports.ExpoPushSendResponseSchema = zod_1.z.object({ data: zod_1.z.array(exports.ExpoPushTicketSchema) });
// A receipt is Expo's follow-up on a ticket once it's actually processed by Apple/Google — same
// shape as a ticket minus the ticket `id` (receipts are keyed by that id in the response instead).
exports.ExpoPushReceiptSchema = zod_1.z.union([
    zod_1.z.object({ status: zod_1.z.literal('ok') }),
    zod_1.z.object({
        status: zod_1.z.literal('error'),
        message: zod_1.z.string(),
        details: zod_1.z.object({ error: zod_1.z.string().optional() }).optional(),
    }),
]);
// Same reason as ExpoPushTicketSchema above
exports.ExpoPushReceiptsResponseSchema = zod_1.z.object({
    data: zod_1.z.record(zod_1.z.string(), exports.ExpoPushReceiptSchema),
});
//# sourceMappingURL=expoPush.js.map